import { TranslationDict } from "../types";

export const enOpbouw: TranslationDict = {
  woning: "House",
  ruimtes: "Rooms",
  uitgangen: "Outputs",
  ingangen: "Inputs",
  aantal: "Amount",
  ruimte: "Room",
  uitgang: "Output",
  maakNaamLeeg: "Clear name",
  geefNaamRuimte: "Give the room a name:",
  voegRuimteToe: "Add room",
  geenRuimteGekozen: "No room selected.",
  moduleBestaatNiet: "This module does not exist.",
  kast: "Cabinet",
  kasten: "Cabinets",
  voegKastToe: "Add cabinet",
  naamKast: "Name of cabinet:",
  naamCtd: "Name of the controller:",
  naamCtdTip: "It is best to choose a unique name to avoid confusion between CTDs.",
  controllers: "Controllers",
  voegCtdToe: "Add CTD",
  offerte: "Offer",
  saOfferte: "SA Offer",
  info: "Info",
  indienst: "In service",
  voegIndienstToe: "Add in service",
  totaalprijs: "Total price",
  module: "Module",
  prijs: "Price",
  totaal: "Total",
  vrije: "Free",
  nietInSa: "The following modules are not available in Stand Alone version:",
  dmx1: "Dimmer",
  dmx6: "RGB",
  dmx8: "RGBW",
  dmx4: "WwKw",
  qdmAddressType: "Address type",
  qdmIndividual: "Individual address",
  qdmGroup: "Group address",
  qdmFixtureCount: "Number of fixtures in group",
  aantalMods: "Number of modules",
  aantalAdressen: "Number of addresses",
  busconsumtion: "Bus consumption",
  typeUitvoering: "Type of finish",
  errorOffSave: "To generate an offer, your project must first be saved.",
  errFullSa: "Please choose FullOfferte or SaOfferte..",
  errGenOff: "An error occurred while generating the offer.",
  errGenOverview: "To generate an overview, your project must first be saved.",
};
